// ============= Create your own prompt — copy =============

export const CREATE_PROMPT_MESSAGES = {
  cardTitle: 'Create your own',
  cardDescription:
    'Build a reusable guided prompt for a task your team runs often.',
  modalTitle: 'Create your own prompt',
  modalDescription:
    'Name your prompt and choose a category. You will get the same step-by-step wizard as our built-in prompts (task, audience, tone, matter-related, and more).',
  fieldTitle: 'Prompt name',
  fieldTitlePlaceholder: 'e.g. Monthly IT steering summary',
  fieldDescription: 'Short description',
  fieldDescriptionPlaceholder: 'What will colleagues use this for?',
  fieldCategory: 'Category',
  save: 'Save prompt',
  cancel: 'Cancel',
  saveSuccess: 'Your prompt was saved and is ready to use',
  saveError: 'Could not save your prompt',
  yourPrompts: 'Your prompts',
  titleRequired: 'Enter a prompt name',
  descriptionRequired: 'Enter a short description',
  deleteAriaLabel: 'Delete prompt',
  deleteModalTitle: 'Delete your prompt',
  deleteModalBody:
    'Are you sure you want to delete this prompt? Saved choices for this prompt will also be removed. This cannot be undone.',
  deleteConfirm: 'Delete prompt',
  deleteCancel: 'Cancel',
  deleteSuccess: 'Your prompt was deleted',
  deleteError: 'Could not delete your prompt',
} as const;
